module.exports = __webpack_public_path__ + "static/img/logo07.d6788f68.png";